




































import { Component, Prop, Vue } from 'vue-property-decorator';

import { ClickEvent } from 'devextreme/ui/button';
import DxButton from 'devextreme-vue/button';

import ChartRenderNew from '@/components/charts/ChartRenderNew.vue';
import { AvailableChartTypes, isApexChartType } from '@/chartHelper';
import { isArray, isNil } from 'lodash';

@Component({
	components: { DxButton, ChartRenderNew }
})
export default class DashboardItem extends Vue {
	@Prop({ type: Object, required: true }) chart!: DashboardChart;
	@Prop({ type: Boolean, default: false }) readonly!: boolean;

	exporting: Record<string, () => void> = {};
	isInDrillDownMode = false;
	drillDownPreviousQuery: string[] = [];

	async reloadQuery(query: string): Promise<void> {
		return;
	}

	get actionsClass(): Array<string | Record<string, boolean>> {
		return [
			'dashboard__grid-item-menu',
			{
				'right-shift': isApexChartType(this.chart.type)
			}
		];
	}

	onChartConfigClick(chart: DashboardChart, event: ClickEvent): void {
		this.$emit('chart:config', { idChart: chart.idChart, event });
	}

	onChartShareClick(chart: DashboardChart, event: ClickEvent): void {
		this.$emit('chart:share', { idChart: chart.idChart, event });
	}

	onChartExportClick(): void {
		if (this.exporting.excel !== undefined)
			this.exporting.excel();
	}

	onChartRemoveClick(chart: DashboardChart, event: ClickEvent): void {
		this.$emit('chart:remove', { idChart: chart.idChart, event });
	}

	onChartBackClick(chart: DashboardChart, event: ClickEvent): void {
		console.log('onChartBackClick');

		if (!isNil(this.drillDownPreviousQuery) && isArray(this.drillDownPreviousQuery) && this.drillDownPreviousQuery.length > 0)
			this.reloadQuery((this.drillDownPreviousQuery as any).pop());

		if (isArray(this.drillDownPreviousQuery) && this.drillDownPreviousQuery.length <= 0)
		this.isInDrillDownMode = false;
	}
}

interface DashboardChart {
	id: string;
	idChart: string;
	idCustomer: string;
	i: string;
	h: number;
	w: number;
	x: number;
	y: number;
	type: AvailableChartTypes;
}
